import React, { useState } from 'react';
import NewsCards from '../Common/Cards/NewsCards';
import { Stack, Pagination } from '@mui/material';

import event1Image from '../../assets/event1.jpg';
import event2Image from '../../assets/event2.jpg';
import event3Image from '../../assets/event3.jpg';
import event4Image from '../../assets/event4.jpg';

function NewsEvents() {
    const newsEvents = [
      {
        _id: 1,
        image: event1Image,
        title: 'CARD TITLE1',
        date: '29/10/1999',
        description:
          "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book.Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book.",
      },
      {
        _id: 2,
        image: event2Image,
        title: 'CARD TITLE2',
        date: '29/10/1999',
        description:
          "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book.",
      },
      {
        _id: 3,
        image: event3Image,
        title: 'CARD TITLE3',
        date: '29/10/1999',
        description:
          "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book.",
      },
      {
        _id: 4,
        image: event4Image,
        title: 'CARD TITLE4',
        date: '29/10/1999',
        description:
          "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book.",
      },
      {
        _id: 5,
        image: event1Image,
        title: 'CARD TITLE5',
        date: '29/10/1999',
        description:
          "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book.",
      },
      {
        _id: 6,
        image: event4Image,
        title: 'CARD TITLE6',
        date: '29/10/1999',
        description:
          "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book.",
      },
    ];

    const [currentPage, setCurrentPage] = useState(1);
    const [itemsPerPage] = useState(6);

    const totalPages = Math.ceil(newsEvents.length / itemsPerPage);
    const paginatedNews = newsEvents.slice(
      (currentPage - 1) * itemsPerPage,
      currentPage * itemsPerPage
    );

    const handlePageChange = (event, value) => {
      setCurrentPage(value);
    };
  return (
    <div className='container my-5'>
      <div className='row d-flex align-items-center justify-content-center mb-4'>
        <div className='col-12 d-flex justify-content-center mb-2 '>
          <h3 className='underline'>News and Events</h3>
        </div>
      </div>
      <div className='row d-flex align-items-center justify-content-center'>
        <NewsCards paginatedNews={paginatedNews}/>
      </div>
      <div className='d-flex justify-content-center'>
        <Stack spacing={2}>
          <Pagination
            count={totalPages}
            page={currentPage}
            onChange={handlePageChange}
            color='success'
          />
        </Stack>
        {/* <Button className='m-3' color='success' variant='outlined'>
            View More
          </Button> */}
      </div>
    </div>
  );
}

export default NewsEvents;
